import {Component, OnInit, Input} from '@angular/core';
import {IsFilterOnService} from '../../../../Services/is-filter-on.service';

@Component({
  selector: 'app-location-select',
  templateUrl: './location-select.component.html',
  styleUrls: ['./location-select.component.css'],
  standalone: false
})
export class LocationSelectComponent implements OnInit {
  @Input() vm: any;

  constructor(public isFiltered: IsFilterOnService) {
  }

  ngOnInit() {
  }

  checkFiltered(): boolean {
    const filteredValue = this.isFiltered.isFiltered(this.vm);
    this.vm.filtered = filteredValue;
    return filteredValue;
  }

}
